import React from "react"
import config from "react-global-configuration"
import BookingUpsale from "../common/BookingUpsale"
import { getCssLegend } from "../../helpers/bookingHelper"
import * as path from "../../constants/Paths"
import { Link } from "react-router-dom"
import useWindowWidth from "../../../hooks/useWindowWidth"

export default function BookingAmendmentProducts(props) {
  const windowWidth = useWindowWidth()

  BookingAmendmentProducts.defaultProps = {
    isUnavailable: false,
    originalBooking: undefined,
  }

  const renderIcon = (isExtra, isCarService) => {
    if (isExtra) {
      return (
        //to do use new refund icon
        <svg className="svg-icon svg-icon--parking">
          <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-parking">
            &nbsp;
          </use>
        </svg>
      )
    } else if (isCarService) {
      return (
        <svg className="svg-icon svg-icon--lounge">
          <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-carservice">
            &nbsp;
          </use>
        </svg>
      )
    }
    return (
      <svg className="svg-icon svg-icon--parking">
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-parking">
          &nbsp;
        </use>
      </svg>
    )
  }

  const isCarparkUpsalable = (carPark) => {
    var upsalableCarparks = ["P15", "P17", "P19"]
    var isUpsaleable = false

    if (upsalableCarparks.includes(carPark.code)) {
      isUpsaleable = true
    }
    return isUpsaleable
  }

  const renderProduct = (
    id,
    productName,
    description = null,
    price,
    isLast,
    isExtra,
    isCarService,
    canCancel,
    isCancelled,
    manageBookingResult,
    usesMemberPrice,
  ) => {
    const textKeys = config.get("textKeys.common.product") || {}
    const isAmendment = props.isAmendment ? true : false
    const changeFromBooking = props.changeFromBooking
    const booking = props.booking
    const legend = getCssLegend(props.carPark.name, props.product.name)

    const query = {
      ad: manageBookingResult?.booking?.arrivalDate || "",
      at: manageBookingResult?.booking?.arrivalTime || "",
      dd: manageBookingResult?.booking?.departureDate || "",
      dt: manageBookingResult?.booking?.departureTime || "",
      affiliate: manageBookingResult?.booking?.voucher || "",
      cfguid: manageBookingResult?.booking?.guid || "",
      email: manageBookingResult?.booking?.email || "",
      reference: manageBookingResult?.booking?.reference || "",
    }

    let isBookingPending = false
    let canEditBooking = false

    if (!isAmendment) {
      isBookingPending = props.isBookingPending(booking)
      canEditBooking = props.canEditBooking(props.cancellationInfo)
    }

    const thirdPartyPromoLabel = booking?.thirdPartyPromoLabelText // label from original booking
    const cfThirdPartyPromoLabel = changeFromBooking?.booking?.thirdPartyPromoLabelText // label from new booking shown in checkout after changing time
    const resultThirdPartyPromoLabel =
      props.result?.thirdPartyPromoLabel === "CPH Profil" && !usesMemberPrice ? "" : props.result?.thirdPartyPromoLabelText // label from new product searched when changing time - hide label if it's CPH Profil and usesMemberPrice is false

    const nameAndLabel =
      windowWidth > 450 ? (
        <h5 className="amend-product-header">{`${productName}${resultThirdPartyPromoLabel ? ` - ${resultThirdPartyPromoLabel}` : ""}`}</h5>
      ) : (
        <h5 className="amend-product-header">
          {productName}
          <br></br>
          {resultThirdPartyPromoLabel ? resultThirdPartyPromoLabel : ""}
        </h5>
      )

    return (
      <React.Fragment key={id}>
        {isAmendment && !isCarService ? ( //once we're in amendment change flow, we show the booking but not the parking extras.
          <div
            className={`basket-product basket-product--slim basket-product--no-delete js--basket-product ${isLast ? "basket-product--last" : ""}
                        ${!canCancel && isAmendment && !props.isFullValueCancellation() && !isCancelled ? "basket-product--disabled" : ""} ${resultThirdPartyPromoLabel ? "shows-promo-label" : ""}`}
          >
            <div className={`basket-product__details`}>
              {description ? (
                <div className="parking-legend parking-legend--list amend-list-view">
                  <span className={`parking-legend__item parking-legend__item--${legend} amend-carpark-view`}>{props.carPark.name}</span>
                  {nameAndLabel}
                </div>
              ) : (
                nameAndLabel
              )}
              {!isAmendment && !isCarService && isBookingPending && canEditBooking ? (
                <Link
                  className="button-link--smalltext change-carpark-button-spacing"
                  to={`${path.SEARCH_AMMEND_BOOKING()}${props.createQueryStrings(query)}`}
                >
                  {textKeys.editCarpark || "Ret P-Anlæg"}
                </Link>
              ) : null}
            </div>
            <div className={`basket-product__price ${props.isUnavailable ? "strikethrough" : ""}`}>
              <span className="basket-product__price__sum">
                <em>{textKeys.valuta || "DKK"}</em> {props.priceFormatter(price, true)}
              </span>
            </div>
            {console.log(isCarService)}
          </div>
        ) : !isAmendment ? ( //when we're on the overview page, we show all products on the order including carservice.
          <div
            className={`basket-product basket-product--slim basket-product--no-delete js--basket-product ${isLast ? "basket-product--last" : ""}
                            ${!canCancel && isAmendment && !props.isFullValueCancellation() && !isCancelled ? "basket-product--disabled" : ""}`}
          >
            <div className="basket-product__details">
              {description ? (
                <div className="parking-legend parking-legend--list amend-list-view">
                  <span className={`parking-legend__item parking-legend__item--${legend} amend-carpark-view`}>
                    {isAmendment ? changeFromBooking?.carPark?.name : props.carPark.name}
                  </span>
                  <h5 className="amend-product-header">
                    {isAmendment
                      ? `${changeFromBooking?.product?.name}${cfThirdPartyPromoLabel ? ` - ${cfThirdPartyPromoLabel}` : ""}`
                      : `${props.product.name}${thirdPartyPromoLabel ? " - " + thirdPartyPromoLabel : ""}`}
                  </h5>
                </div>
              ) : (
                <h5 className="amend-product-header">{`${productName} - ${
                  props.extras[0].offerLines[0].name
                }${thirdPartyPromoLabel ? " - " + thirdPartyPromoLabel : ""}`}</h5>
              )}
              {!isAmendment && !isCarService && isBookingPending && canEditBooking ? (
                <Link
                  className="button-link--smalltext change-carpark-button-spacing"
                  to={`${path.SEARCH_AMMEND_BOOKING()}${props.createQueryStrings(query)}`}
                >
                  {textKeys.editCarpark || "Ret P-Anlæg"}
                </Link>
              ) : null}
            </div>
            <div className={`basket-product__price ${props.isUnavailable ? "strikethrough" : ""}`}>
              <span className="basket-product__price__sum">
                <em>{textKeys.valuta || "DKK"}</em> {props.priceFormatter(price, true)}
              </span>
            </div>
          </div>
        ) : null}

        {!canCancel && isAmendment && isCarService ? (
          <div className="form__notice form__notice--box">
            {textKeys.refundOnlyOnline || "Det er ikke muligt at få refunderet bilpleje via hjemmesiden, dette skal gøres hos Københavns bilpleje"}
          </div>
        ) : null}
        {!canCancel && !isCancelled && isAmendment && !isCarService && !props.isFullValueCancellation() ? (
          <div className="form__notice form__notice--box">
            {textKeys.refundNotAvailable || "Det er ikke muligt at refundere refunderingsgarantien"}
          </div>
        ) : null}
      </React.Fragment>
    )
  }

  const renderExtraItems = (extra, i, booking, canCancel, isCancelled, isLast) => {
    const extraName = props.extras.find((e) => e.id === extra.extraId)?.name
    const isAmendment = props.isAmendment ? true : false
    const textKeys = config.get("textKeys.common.product") || {}
    return (
      <div
        key={extraName + i}
        className={`basket-product basket-product--slim basket-product--no-delete js--basket-product ${isLast ? "basket-product--last" : ""}
        ${!canCancel && isAmendment && !props.isFullValueCancellation() && !isCancelled ? "basket-product--disabled" : ""}`}
      >
        {extra.offerLines.map((variant, index) => {
          const extraVariant = getExtraVariant(extra.extraId, variant.extraOfferLineId)
          const price = getExtraOfferLinePrice(variant, booking)
          return (
            <div className="basket-product__wrapper" key={extraVariant.name + index}>
              <div className="basket-product__details">
                <h5 className="amend-product-header">{`${extraName} - ${extraVariant.name}`}</h5>
              </div>
              <div className={`basket-product__price ${props.isUnavailable ? "strikethrough" : ""}`}>
                <span className="basket-product__price__sum">
                  <em>{textKeys.valuta || "DKK"}</em> {props.priceFormatter(price, true)}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  const getExtraVariant = (extraId, variantId) => {
    const extras = props.extras
    const variants = extras.find((e) => e.id === extraId)?.offerLines
    const variant = variants.find((v) => v.id === variantId)
    return variant
  }

  const getExtraOfferLinePrice = (offerLine, booking) => {
    if (!offerLine) return 0
    if (!booking) return 0
    return offerLine.amount
  }

  // Directly moving the old render logic into our functional component:
  const { booking, originalBooking, result, product, carPark, extras, noLastStyling, isCancelled, changeFromBooking, userAccountDetails, parking } =
    props
  const bookingResult = { carPark: carPark, product: product, booking: booking }
  let parkingPrice = 0
  let bookingWithExtras = undefined

  let isBookingPending = false
  let canEditBooking = false

  if (!props.isAmendment) {
    isBookingPending = props.isBookingPending(props.booking)
    canEditBooking = props.canEditBooking(props.cancellationInfo)
  }

  let originalMembership = originalBooking?.membershipNumber ? true : false
  let changeFromMembership = changeFromBooking?.booking?.membershipNumber ? true : false
  let loggedInMembership = userAccountDetails?.CustomerNumber ? true : false
  let membershipCarParks = [77, 71]
  let weekendParkingProducts = [115]
  let usesMemberPrice = false

  var isUpsale = isCarparkUpsalable(carPark)

  if (booking) {
    parkingPrice = parking.originalAmount ?? parking.amount // fallback to amount if originalAmount is null
    if (booking.promotionCode && booking.promotionSaving > 0) {
      parkingPrice = parking.originalAmount
    } else if (!!booking.affiliateCode && !booking.useMemberPrice && parking.amount < parking.originalAmount) {
      parkingPrice = parking.amount
    } else if (booking.useMemberPrice) {
      parkingPrice = parking.amount
    } else if (parking.isParkingUpgrade) {
      parkingPrice = parking.amount
    }
    bookingWithExtras = booking
  } else {
    if (
      membershipCarParks.includes(result?.carPark) &&
      result?.showMemberPrice &&
      (originalMembership || changeFromMembership || loggedInMembership)
    ) {
      if (result.memberPrice === 0) {
        parkingPrice = result.originalPrice
      } else {
        parkingPrice = result.memberPrice
        usesMemberPrice = true
      }
    } else {
      parkingPrice = result.totalPrice
    }
    bookingWithExtras = originalBooking
  }

  return (
    <React.Fragment>
      {product
        ? renderProduct(
            product.id,
            product.name,
            carPark.name,
            parkingPrice,
            noLastStyling ? false : booking?.items?.extras?.length === 0,
            booking?.items?.extras ? true : false,
            false,
            product.canCancel,
            isCancelled,
            bookingResult,
            usesMemberPrice,
          )
        : null}
      {props.bookingUpsale && !props.bookingUpsale.product.isSoldOut && isUpsale && isBookingPending && canEditBooking ? (
        props.loadedFromAmendment ? (
          <div className="side-border-amdendment">
            <BookingUpsale bookingResult={bookingResult} innerForm={true} isAmendment={props.isAmendment} {...props} />
          </div>
        ) : (
          <BookingUpsale bookingResult={bookingResult} innerForm={true} isAmendment={props.isAmendment} {...props} />
        )
      ) : null}
      {!!booking?.items?.extras[0] && !props.isAmendment
        ? booking.items.extras.map((extra, index) =>
            renderExtraItems(extra, index, bookingWithExtras, extra.canCancel, isCancelled, noLastStyling ? false : extras.length - 1 === index),
          )
        : null}
    </React.Fragment>
  )
}

// Attach the defaultProps to the functional component.
BookingAmendmentProducts.defaultProps = {
  isUnavailable: false,
  originalBooking: undefined,
}
